import { useSnackbar } from "notistack";
import { State } from "../../../domain/model/ResponseState";
import { useEffect, useState } from "react";
import { GetAllStatsUseCase } from "../../../domain/usecase/stats/getAll/GetAllStatsUseCase";
import { AllStats } from "../../../domain/model/Stats";

export function StatsViewModel(getAllStatsUseCase: GetAllStatsUseCase) {
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [allStats, setAllStats] = useState<AllStats>();

  useEffect(() => {
    getAllStats();
  }, []);

  async function getAllStats() {
    setLoading(true);
    const response = await getAllStatsUseCase.invoke();
    setLoading(false);
    switch (response.responseState) {
      case State.Success:
        if (!response.data) return;
        setAllStats(response.data);
        break;
      case State.Fail:
      case State.Error:
        showSnackbar(response.error?.message);
        break;
    }
  }

  function showSnackbar(
    message: string | undefined,
    variant: "error" | "success" = "error",
  ) {
    if (message) enqueueSnackbar(message, { variant: variant });
  }

  return { allStats, loading };
}
